// @ts-nocheck
/**
 * ClipBuds Template
 * 滚动淡入；KV 导航滚过首屏后吸顶；产品卡切卡与换底图；生活场景轮播；
 * 清晰通话手风琴；优惠码复制。断点与 CSS 一致：(max-width: 1023.98px)。
 */
(function () {
  'use strict';

  const TAG_NAME = 'clipbuds-template-section';
  if (customElements.get(TAG_NAME)) return;

  const CBT_FORM_SUBMIT_URL = 'https://ecf.cirkleinc.com/api/form-submit';

  const MOBILE_MQ = '(max-width: 1023.98px)';
  const CBT_KV_NAV_ANCHOR_GAP_BELOW_NAV_PX = 8;
  const CBT_KV_NAV_ANCHOR_EXTRA_SCROLL_PX = 20;
  /* 与 CSS --cbt-* 对齐：轮播位移 / 自动切 / 防抖 */
  const CBT_MOTION = Object.freeze({
    slideMs: 400,
    autoplayMs: 5000,
    resizeDebounceMs: 220,
    swiperPollMs: 80
  });
  /* 节奏对齐专题沉淀：只播一次，标题→内容错开 0.18s */
  const CBT_REVEAL = Object.freeze({
    y: 26,
    duration: 0.88,
    ease: 'power2.out',
    start: 'top 70%',
    stagger: 0.18
  });

  function cbtPrefersReducedMotion() {
    return (
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  /* clipboard API 失败时回退 execCommand，避免复制成功态空转 */
  function cbtCopyText(text, onDone) {
    const done = typeof onDone === 'function' ? onDone : () => {};
    const fallback = () => {
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.cssText = 'position:fixed;left:-9999px;opacity:0';
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand('copy');
      } catch (_) {}
      ta.remove();
      done();
    };
    if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
      navigator.clipboard.writeText(text).then(done).catch(fallback);
      return;
    }
    fallback();
  }

  function cbtUi(root, name, fallback) {
    const value = root instanceof HTMLElement ? root.getAttribute(name) : '';
    return value || fallback;
  }

  /* 选中的 tab 可聚焦，其余移出 Tab 序 */
  function cbtSetTab(tab, on) {
    tab.setAttribute('aria-selected', on ? 'true' : 'false');
    tab.tabIndex = on ? 0 : -1;
  }

  /**
   * 监听断点变化并登记解绑，兼容只有 addListener 的旧 Safari。
   *
   * @param {MediaQueryList} mq
   * @param {() => void} onChange
   * @param {Array<() => void>} cleanups
   */
  function cbtOnMqChange(mq, onChange, cleanups) {
    if (!mq) return;
    if (typeof mq.addEventListener === 'function') mq.addEventListener('change', onChange);
    else if (typeof mq.addListener === 'function') mq.addListener(onChange);
    else return;
    cleanups.push(() => {
      if (typeof mq.removeEventListener === 'function') mq.removeEventListener('change', onChange);
      else if (typeof mq.removeListener === 'function') mq.removeListener(onChange);
    });
  }

  /**
   * 方向键在一组 tab 里移动，Home / End 到两端。
   *
   * @param {HTMLElement[]} tabs
   * @param {(index: number) => void} onSelect
   * @param {Array<() => void>} cleanups
   */
  function bindCbtRovingTabs(tabs, onSelect, cleanups) {
    const list = tabs.filter((tab) => tab instanceof HTMLElement);
    if (list.length < 2) return;
    const onKey = (e) => {
      const current = list.indexOf(document.activeElement);
      if (current < 0) return;
      let next = current;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (current + 1) % list.length;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (current - 1 + list.length) % list.length;
      else if (e.key === 'Home') next = 0;
      else if (e.key === 'End') next = list.length - 1;
      else return;
      e.preventDefault();
      onSelect(next);
      if (list[next] instanceof HTMLElement) list[next].focus();
    };
    list.forEach((tab) => {
      tab.addEventListener('keydown', onKey);
      cleanups.push(() => tab.removeEventListener('keydown', onKey));
    });
  }

  /* resize 合并到一拍，避免拖窗口时连续量布局 */
  function cbtOnResize(fn, cleanups) {
    let timer = 0;
    const onResize = () => {
      window.clearTimeout(timer);
      timer = window.setTimeout(fn, CBT_MOTION.resizeDebounceMs);
    };
    window.addEventListener('resize', onResize, { passive: true });
    cleanups.push(() => {
      window.clearTimeout(timer);
      window.removeEventListener('resize', onResize);
    });
  }

  /**
   * 进入视口 5 秒后自动切下一张，离开视口停掉。手动操作调用 restart 重新计时。
   *
   * @param {HTMLElement} el
   * @param {Array<() => void>} cleanups
   * @param {() => void} advance
   * @param {(playing: boolean) => void} [onArm] 计时开始或停下时通知，用来重跑进度条
   * @param {{ pauseOnHover?: boolean, enabled?: () => boolean }} [options]
   *   pauseOnHover 为 false 时悬停也照常计时；enabled 返回 false 时完全不起计时
   * @returns {{ restart: () => void, hold: () => void }}
   */
  function bindCbtAutoplay(el, cleanups, advance, onArm, options) {
    let timer = 0;
    let inView = false;
    const pauseOnHover = !options || options.pauseOnHover !== false;
    const enabled = options && typeof options.enabled === 'function' ? options.enabled : null;
    /* 鼠标停在模块上时不自动切，移开后再重新计时 */
    let pointerOver = false;
    const arm = (playing) => {
      if (typeof onArm === 'function') onArm(!!playing);
    };
    const clearTimer = () => {
      if (!timer) return;
      window.clearInterval(timer);
      timer = 0;
    };
    const restart = () => {
      clearTimer();
      arm(false);
      if (enabled && !enabled()) return;
      if (!inView || (pauseOnHover && pointerOver) || cbtPrefersReducedMotion()) return;
      arm(true);
      timer = window.setInterval(advance, CBT_MOTION.autoplayMs);
    };
    if (!(el instanceof HTMLElement)) return { restart, hold: clearTimer };
    if (pauseOnHover) {
      const onPointerEnter = () => {
        pointerOver = true;
        clearTimer();
        arm(false);
      };
      const onPointerLeave = () => {
        pointerOver = false;
        if (inView && !document.hidden) restart();
      };
      el.addEventListener('mouseenter', onPointerEnter);
      el.addEventListener('mouseleave', onPointerLeave);
      cleanups.push(() => {
        el.removeEventListener('mouseenter', onPointerEnter);
        el.removeEventListener('mouseleave', onPointerLeave);
      });
    }
    if (typeof IntersectionObserver === 'function') {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            inView = entry.isIntersecting;
            if (inView) restart();
            else {
              clearTimer();
              arm(false);
            }
          });
        },
        { threshold: 0.35 }
      );
      io.observe(el);
      cleanups.push(() => io.disconnect());
    } else {
      inView = true;
      restart();
    }
    const onHide = () => {
      if (document.hidden) {
        clearTimer();
        arm(false);
      } else restart();
    };
    document.addEventListener('visibilitychange', onHide);
    cleanups.push(() => {
      document.removeEventListener('visibilitychange', onHide);
      clearTimer();
    });
    return { restart, hold: clearTimer };
  }

  /* 首屏视频：桌面 / 手机各播一次，文案不随播放淡入 */
  function initClipbudsKvVideo(root, ctx) {
    const { cleanups } = ctx;
    const kv = root.querySelector('[data-cbt-kv]');
    if (!(kv instanceof HTMLElement)) return;

    const poster = kv.querySelector('.ug-clipbuds-template__kv-picture');
    const pcVideo = kv.querySelector('.ug-clipbuds-template__kv-video--pc');
    const moVideo = kv.querySelector('.ug-clipbuds-template__kv-video--mo');
    if (!(pcVideo instanceof HTMLVideoElement) && !(moVideo instanceof HTMLVideoElement)) return;

    if (cbtPrefersReducedMotion()) return;

    let lastIsMobile = null;
    let raf = 0;

    const pauseVideo = (video) => {
      if (!(video instanceof HTMLVideoElement)) return;
      try {
        video.pause();
      } catch (_) {}
      video.classList.remove('is-visible');
    };

    const playVideo = (video) => {
      if (!(video instanceof HTMLVideoElement) || !video.isConnected) return;
      const source = video.querySelector('source');
      const src = source ? source.getAttribute('src') : '';
      if (!src || !src.trim()) return;

      try {
        video.muted = true;
        video.playsInline = true;
        video.loop = false;
        video.preload = 'auto';
      } catch (_) {}

      const show = () => {
        if (!video.isConnected) return;
        video.classList.add('is-visible');
        if (poster instanceof HTMLElement) poster.classList.add('is-hidden');
        const pending = video.play();
        if (pending && typeof pending.catch === 'function') pending.catch(() => {});
      };

      if (video.readyState >= 2) {
        show();
        return;
      }
      video.addEventListener('canplay', show, { once: true });
      try {
        video.load();
      } catch (_) {}
    };

    const sync = () => {
      const isMobile = window.matchMedia(MOBILE_MQ).matches;
      if (lastIsMobile !== null && lastIsMobile === isMobile) return;
      lastIsMobile = isMobile;
      const active = isMobile ? moVideo : pcVideo;
      const inactive = isMobile ? pcVideo : moVideo;
      pauseVideo(inactive);
      /* 切端时先露出海报，等当前端视频能播再盖上 */
      if (poster instanceof HTMLElement) poster.classList.remove('is-hidden');
      playVideo(active);
    };

    const onResize = () => {
      if (raf) window.cancelAnimationFrame(raf);
      raf = window.requestAnimationFrame(() => {
        raf = 0;
        sync();
      });
    };

    sync();
    window.addEventListener('resize', onResize, { passive: true });
    cleanups.push(() => {
      window.removeEventListener('resize', onResize);
      if (raf) window.cancelAnimationFrame(raf);
      pauseVideo(pcVideo);
      pauseVideo(moVideo);
    });
  }

  /**
   * KV 导航：fixed 不占文档流；初始隐藏，滚过 KV 底部后滑入；滚回 KV 上方再收起。
   * 手机端：左侧品牌，右侧下箭头展开锚点，Shop now 保持可见。
   *
   * @param {HTMLElement} root
   * @param {{ cleanups: Array<() => void>, reduced: boolean }} ctx
   */
  function initClipbudsKvNav(root, ctx) {
    const nav = root.querySelector('[data-cbt-kv-nav]');
    if (!(nav instanceof HTMLElement)) {
      return;
    }

    const kvEl = root.querySelector('[data-cbt-kv]');
    const buyBtn = nav.querySelector('[data-cbt-kv-nav-buy]');
    const kvShopBtn = root.querySelector('[data-cbt-kv-shop]');
    const buyTarget = root.querySelector('#cbt-editions') || document.querySelector('#cbt-editions');
    const dropdownToggle = nav.querySelector('[data-cbt-kv-nav-dropdown-toggle]');
    const dropdownPanel = nav.querySelector('[data-cbt-kv-nav-dropdown]');
    let closeMobileKvMenu = () => {};

    let kvRevealThreshold = 0;

    const measureKvRevealThreshold = () => {
      if (kvEl instanceof HTMLElement) {
        const rect = kvEl.getBoundingClientRect();
        const sy0 = window.scrollY;
        kvRevealThreshold = Math.max(0, Math.round(rect.bottom + sy0));
        return;
      }
      kvRevealThreshold = 0;
    };

    const closeDropdownForStickyHide = () => {
      closeMobileKvMenu();
      if (dropdownPanel instanceof HTMLElement && dropdownPanel.dataset.cbtKvDdMounted !== '1') {
        dropdownPanel.hidden = true;
      }
    };

    const finishLeave = () => {
      nav.classList.remove('is-kv-sticky', 'is-kv-sticky-leaving', 'is-kv-sticky-settled');
      nav.classList.add('is-kv-nav-before-kv');
      nav.setAttribute('aria-hidden', 'true');
      closeDropdownForStickyHide();
      window.requestAnimationFrame(() => {
        measureKvRevealThreshold();
      });
    };

    const onNavAnimEnd = (ev) => {
      if (!(ev instanceof AnimationEvent) || ev.target !== nav) {
        return;
      }
      if (ev.animationName === 'ug-cbt-kv-nav-slide-out') {
        finishLeave();
        return;
      }
      /* 滑入结束后摘掉 animation，避免父级 opacity 合成层让 Buy hover 闪一下 */
      if (ev.animationName === 'ug-cbt-kv-nav-slide-in') {
        nav.classList.add('is-kv-sticky-settled');
      }
    };

    const startLeave = () => {
      if (!nav.classList.contains('is-kv-sticky') || nav.classList.contains('is-kv-sticky-leaving')) {
        return;
      }
      closeDropdownForStickyHide();
      nav.classList.remove('is-kv-sticky-settled');
      if (ctx.reduced) {
        finishLeave();
        return;
      }
      nav.classList.add('is-kv-sticky-leaving');
    };

    measureKvRevealThreshold();

    let ticking = false;
    /* 锚点收集完后赋值，滚动时按当前板块点亮下划线 */
    let syncActiveNav = () => {};
    const updateStickyState = () => {
      ticking = false;
      const sy = window.scrollY;
      const wantVisible = sy >= kvRevealThreshold;

      if (nav.classList.contains('is-kv-sticky-leaving')) {
        if (wantVisible) {
          nav.classList.remove('is-kv-sticky-leaving');
          nav.classList.add('is-kv-sticky', 'is-kv-sticky-settled');
        }
        syncActiveNav();
        return;
      }

      if (wantVisible) {
        if (nav.classList.contains('is-kv-nav-before-kv')) {
          nav.classList.remove('is-kv-nav-before-kv');
          nav.removeAttribute('aria-hidden');
          if (!ctx.reduced) {
            void nav.offsetHeight;
          }
          nav.classList.remove('is-kv-sticky-leaving', 'is-kv-sticky-settled');
          nav.classList.add('is-kv-sticky');
          if (ctx.reduced) {
            nav.classList.add('is-kv-sticky-settled');
          }
        } else if (!nav.classList.contains('is-kv-sticky')) {
          nav.classList.add('is-kv-sticky');
          if (ctx.reduced) {
            nav.classList.add('is-kv-sticky-settled');
          }
        }
      } else if (nav.classList.contains('is-kv-sticky')) {
        startLeave();
      } else if (!nav.classList.contains('is-kv-nav-before-kv')) {
        nav.classList.add('is-kv-nav-before-kv');
        nav.setAttribute('aria-hidden', 'true');
      }
      syncActiveNav();
    };

    const requestStickyUpdate = () => {
      if (ticking) {
        return;
      }
      ticking = true;
      window.requestAnimationFrame(updateStickyState);
    };

    const onResize = () => {
      measureKvRevealThreshold();
      requestStickyUpdate();
    };

    requestStickyUpdate();
    nav.addEventListener('animationend', onNavAnimEnd);
    window.addEventListener('scroll', requestStickyUpdate, { passive: true });
    window.addEventListener('resize', onResize, { passive: true });
    ctx.cleanups.push(() => window.removeEventListener('scroll', requestStickyUpdate));
    ctx.cleanups.push(() => window.removeEventListener('resize', onResize));
    ctx.cleanups.push(() => {
      nav.removeEventListener('animationend', onNavAnimEnd);
      nav.classList.remove(
        'is-kv-sticky',
        'is-kv-sticky-leaving',
        'is-kv-sticky-settled',
        'is-kv-nav-before-kv'
      );
      nav.removeAttribute('aria-hidden');
    });

    const jumpTo = (targetEl) => {
      if (!(targetEl instanceof HTMLElement)) {
        return;
      }
      const sy = window.scrollY;
      const navH = Math.max(0, Math.round(nav.getBoundingClientRect().height));
      const targetTop = targetEl.getBoundingClientRect().top + sy;
      const nextTop = Math.max(
        0,
        targetTop - navH - CBT_KV_NAV_ANCHOR_GAP_BELOW_NAV_PX + CBT_KV_NAV_ANCHOR_EXTRA_SCROLL_PX
      );
      window.scrollTo({
        top: nextTop,
        behavior: ctx.reduced ? 'auto' : 'smooth'
      });
    };

    const getHashFromHref = (href) => {
      if (typeof href !== 'string' || href.length === 0) {
        return '';
      }
      if (href.startsWith('#')) {
        return href;
      }
      try {
        const url = new URL(href, window.location.href);
        return url.hash || '';
      } catch (_) {
        return '';
      }
    };

    const getTargetByHash = (hash) => {
      if (typeof hash !== 'string' || !hash.startsWith('#')) {
        return null;
      }
      const target = root.querySelector(hash) || document.querySelector(hash);
      return target instanceof HTMLElement ? target : null;
    };

    const anchorEls = Array.from(nav.querySelectorAll('[data-cbt-kv-nav-anchor]'));
    /** @type {Array<{ hash: string, el: HTMLElement }>} */
    const navTargets = [];
    const seenNavHash = new Set();
    anchorEls.forEach((el) => {
      if (!(el instanceof HTMLAnchorElement)) return;
      const hash = getHashFromHref(el.getAttribute('href') || '');
      if (!hash || seenNavHash.has(hash)) return;
      const target = getTargetByHash(hash);
      if (!target) return;
      seenNavHash.add(hash);
      navTargets.push({ hash, el: target });
    });

    const setActiveNavLink = (href) => {
      const hash = getHashFromHref(href);
      nav.querySelectorAll('[data-cbt-kv-nav-anchor]').forEach((el) => {
        if (!(el instanceof HTMLElement)) return;
        const isMatch = getHashFromHref(el.getAttribute('href') || '') === hash && hash !== '';
        el.classList.toggle('is-active', isMatch);
        if (isMatch) el.setAttribute('aria-current', 'true');
        else el.removeAttribute('aria-current');
      });
    };

    syncActiveNav = () => {
      const barVisible = nav.classList.contains('is-kv-sticky');
      const navH = barVisible ? Math.max(0, Math.round(nav.getBoundingClientRect().height)) : 0;
      const line = navH + 16;
      let current = '';
      navTargets.forEach((item) => {
        if (item.el.getBoundingClientRect().top <= line) current = item.hash;
      });
      setActiveNavLink(current);
    };
    syncActiveNav();

    const onAnchorClick = (ev) => {
      const link = ev.currentTarget;
      if (!(link instanceof HTMLAnchorElement)) {
        return;
      }
      const href = link.getAttribute('href') || '';
      const hash = getHashFromHref(href);
      const target = getTargetByHash(hash);
      if (!target) {
        return;
      }
      ev.preventDefault();
      setActiveNavLink(href);
      if (dropdownPanel instanceof HTMLElement && dropdownPanel.contains(link)) {
        closeMobileKvMenu();
      }
      jumpTo(target);
    };
    anchorEls.forEach((el) => {
      el.addEventListener('click', onAnchorClick);
      ctx.cleanups.push(() => el.removeEventListener('click', onAnchorClick));
    });

    const onBuyNowClick = (ev) => {
      if (!(buyTarget instanceof HTMLElement)) {
        return;
      }
      ev.preventDefault();
      jumpTo(buyTarget);
    };
    if (buyBtn instanceof HTMLElement) {
      buyBtn.addEventListener('click', onBuyNowClick);
      ctx.cleanups.push(() => buyBtn.removeEventListener('click', onBuyNowClick));
    }
    if (kvShopBtn instanceof HTMLElement) {
      kvShopBtn.addEventListener('click', onBuyNowClick);
      ctx.cleanups.push(() => kvShopBtn.removeEventListener('click', onBuyNowClick));
    }

    if (dropdownToggle instanceof HTMLElement && dropdownPanel instanceof HTMLElement) {
      const mqMobile = window.matchMedia(MOBILE_MQ);

      dropdownPanel.removeAttribute('hidden');
      dropdownPanel.dataset.cbtKvDdMounted = '1';

      const closeDropdown = () => {
        nav.classList.remove('is-kv-dropdown-open');
        dropdownToggle.setAttribute('aria-expanded', 'false');
      };

      const openDropdown = () => {
        nav.classList.add('is-kv-dropdown-open');
        dropdownToggle.setAttribute('aria-expanded', 'true');
      };

      const toggleDropdown = () => {
        if (nav.classList.contains('is-kv-dropdown-open')) {
          closeDropdown();
          return;
        }
        openDropdown();
      };

      const onToggleClick = (ev) => {
        if (!mqMobile.matches) return;
        ev.preventDefault();
        ev.stopPropagation();
        toggleDropdown();
      };

      const onDocumentClick = (ev) => {
        if (!(ev.target instanceof Node)) {
          return;
        }
        const t = ev.target;
        if (t === dropdownToggle || dropdownToggle.contains(t)) {
          return;
        }
        if (t === dropdownPanel || dropdownPanel.contains(t)) {
          return;
        }
        if (!nav.contains(t)) {
          window.requestAnimationFrame(() => {
            closeDropdown();
          });
        }
      };

      const onKeyDown = (ev) => {
        if (ev.key === 'Escape') {
          closeDropdown();
        }
      };

      const onViewportChange = () => {
        if (!mqMobile.matches) {
          closeDropdown();
        }
      };

      closeDropdown();
      dropdownToggle.addEventListener('click', onToggleClick);
      document.addEventListener('click', onDocumentClick);
      document.addEventListener('keydown', onKeyDown);
      window.addEventListener('resize', onViewportChange, { passive: true });
      ctx.cleanups.push(() => dropdownToggle.removeEventListener('click', onToggleClick));
      ctx.cleanups.push(() => document.removeEventListener('click', onDocumentClick));
      ctx.cleanups.push(() => document.removeEventListener('keydown', onKeyDown));
      ctx.cleanups.push(() => window.removeEventListener('resize', onViewportChange));
      ctx.cleanups.push(() => closeDropdown());

      closeMobileKvMenu = closeDropdown;
    }
  }

  /**
   * 桌面 Tab / 箭头切卡；手机端全部堆叠，不切。
   *
   * @param {HTMLElement} root
   * @param {{ cleanups: Array<() => void> }} ctx
   */
  function initClipbudsEditionsTabs(root, ctx) {
    const { cleanups } = ctx;
    root.querySelectorAll('[data-cbt-editions]').forEach((section) => {
      if (!(section instanceof HTMLElement)) return;
      const tabs = Array.from(section.querySelectorAll('[data-cbt-editions-tab]'));
      const cards = Array.from(section.querySelectorAll('[data-cbt-editions-card]'));
      if (!cards.length) return;

      let index = Math.max(
        0,
        cards.findIndex((card) => card.classList.contains('is-active'))
      );
      if (index < 0) index = 0;

      const list = section.querySelector('[data-cbt-editions-list]');
      const prev = section.querySelector('[data-cbt-editions-nav-prev]');
      const next = section.querySelector('[data-cbt-editions-nav-next]');

      const syncNav = () => {
        const total = cards.length;
        const atStart = index <= 0;
        const atEnd = index >= total - 1;
        if (prev instanceof HTMLButtonElement) {
          prev.disabled = atStart;
          prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
        }
        if (next instanceof HTMLButtonElement) {
          next.disabled = atEnd;
          next.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
        }
      };

      const apply = (nextIndex) => {
        const total = cards.length;
        if (!total) return;
        index = Math.max(0, Math.min(total - 1, nextIndex));
        cards.forEach((card, i) => {
          card.classList.toggle('is-active', i === index);
        });
        tabs.forEach((tab, i) => {
          const on = i === index;
          tab.classList.toggle('is-active', on);
          cbtSetTab(tab, on);
        });
        if (list instanceof HTMLElement) {
          list.style.setProperty('--cbt-editions-index', String(index));
        }
        syncNav();
      };

      tabs.forEach((tab, i) => {
        const onClick = () => apply(i);
        tab.addEventListener('click', onClick);
        cleanups.push(() => tab.removeEventListener('click', onClick));
      });
      bindCbtRovingTabs(tabs, apply, cleanups);

      if (prev instanceof HTMLElement) {
        const onPrev = () => {
          if (index <= 0) return;
          apply(index - 1);
        };
        prev.addEventListener('click', onPrev);
        cleanups.push(() => prev.removeEventListener('click', onPrev));
      }
      if (next instanceof HTMLElement) {
        const onNext = () => {
          if (index >= cards.length - 1) return;
          apply(index + 1);
        };
        next.addEventListener('click', onNext);
        cleanups.push(() => next.removeEventListener('click', onNext));
      }

      apply(index);
    });
  }

  /**
   * 生活场景循环跟 Magflow 同一套：整组前后各克隆一份，按卡片 offset 居中，
   * 滑到克隆段再瞬间补回中间真卡，头尾不会空一块。
   *
   * @param {HTMLElement} root
   * @param {{ cleanups: Array<() => void> }} ctx
   */
  function initClipbudsScenes(root, ctx) {
    const { cleanups } = ctx;
    const mobileMq =
      typeof window.matchMedia === 'function' ? window.matchMedia(MOBILE_MQ) : null;

    root.querySelectorAll('[data-cbt-scenes]').forEach((section) => {
      if (!(section instanceof HTMLElement)) return;
      const viewport = section.querySelector('[data-cbt-scenes-viewport]');
      const list = section.querySelector('[data-cbt-scenes-list]');
      const prev = section.querySelector('[data-cbt-scenes-prev]');
      const next = section.querySelector('[data-cbt-scenes-next]');
      const tabsEl = section.querySelector('[data-cbt-scenes-tabs]');
      const fadeNextEl =
        section.querySelector('[data-cbt-scenes-tabs-fade-next]') ||
        section.querySelector('[data-cbt-scenes-tabs-fade]');
      const fadePrevEl = section.querySelector('[data-cbt-scenes-tabs-fade-prev]');
      const tabs = Array.from(section.querySelectorAll('[data-cbt-scenes-tab]'));
      const captions = Array.from(section.querySelectorAll('[data-cbt-scenes-caption]'));
      const cards = Array.from(section.querySelectorAll('[data-cbt-scenes-slide]')).filter(
        (slide) => slide instanceof HTMLElement && !slide.hasAttribute('data-cbt-scenes-clone')
      );
      if (!(viewport instanceof HTMLElement) || !(list instanceof HTMLElement) || !cards.length) {
        return;
      }

      const realCount = cards.length;
      const loopEnabled = realCount > 1;

      const resetClone = (cloneRoot) => {
        if (!(cloneRoot instanceof HTMLElement)) return;
        cloneRoot.classList.remove('is-active');
        cloneRoot.setAttribute('aria-hidden', 'true');
        cloneRoot.setAttribute('data-cbt-scenes-clone', '1');
        cloneRoot.removeAttribute('id');
      };
      const cloneCardSet = () => {
        const frag = document.createDocumentFragment();
        cards.forEach((card) => {
          const clone = card.cloneNode(true);
          resetClone(clone);
          frag.appendChild(clone);
        });
        return frag;
      };

      list.querySelectorAll('[data-cbt-scenes-clone]').forEach((el) => el.remove());
      if (loopEnabled) {
        list.insertBefore(cloneCardSet(), list.firstChild);
        list.appendChild(cloneCardSet());
      }
      cleanups.push(() => {
        list.querySelectorAll('[data-cbt-scenes-clone]').forEach((el) => el.remove());
        list.style.willChange = 'auto';
        list.style.removeProperty('transition');
        list.style.removeProperty('transform');
      });

      const slides = Array.from(list.children).filter((slide) => slide instanceof HTMLElement);
      let currentSlide = loopEnabled ? realCount : 0;
      let activeIndex = 0;

      const getRealIndexBySlide = (slideIndex) => {
        if (!loopEnabled) return Math.max(0, Math.min(slideIndex, realCount - 1));
        return ((slideIndex % realCount) + realCount) % realCount;
      };

      const getTargetTranslateX = (slideIndex) => {
        const activeCard = slides[slideIndex];
        if (!(activeCard instanceof HTMLElement) || viewport.clientWidth <= 0) return 0;
        if (mobileMq && mobileMq.matches) {
          const pad = Number.parseFloat(window.getComputedStyle(list).paddingLeft) || 0;
          return -(activeCard.offsetLeft - pad);
        }
        return -(activeCard.offsetLeft + activeCard.offsetWidth / 2 - viewport.clientWidth / 2);
      };

      /* 手机 Tab 箭头按真实序号收起：第一项藏左，最后一项藏右 */
      const syncNav = () => {
        const disableEnds = !loopEnabled;
        const atStart = disableEnds && activeIndex <= 0;
        const atEnd = disableEnds && activeIndex >= realCount - 1;
        if (prev instanceof HTMLButtonElement) {
          prev.disabled = atStart;
          prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
        }
        if (next instanceof HTMLButtonElement) {
          next.disabled = atEnd;
          next.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
        }
        const tabAtStart = activeIndex <= 0 || realCount <= 1;
        const tabAtEnd = activeIndex >= realCount - 1 || realCount <= 1;
        const syncFade = (el, hidden) => {
          if (!(el instanceof HTMLElement)) return;
          el.classList.toggle('is-hidden', hidden);
          if (hidden) el.setAttribute('aria-hidden', 'true');
          else el.removeAttribute('aria-hidden');
          if (el instanceof HTMLButtonElement) {
            el.disabled = hidden;
            el.setAttribute('aria-disabled', hidden ? 'true' : 'false');
          }
        };
        syncFade(fadePrevEl, tabAtStart);
        syncFade(fadeNextEl, tabAtEnd);
        if (tabsEl instanceof HTMLElement) {
          tabsEl.classList.toggle('has-prev', !tabAtStart);
          tabsEl.classList.toggle('has-next', !tabAtEnd);
        }
      };

      const scrollActiveTab = (immediate) => {
        const tab = tabs[activeIndex];
        if (!(tabsEl instanceof HTMLElement) || !(tab instanceof HTMLElement)) return;
        if (!mobileMq || !mobileMq.matches) return;
        const tabRect = tab.getBoundingClientRect();
        const scrollerRect = tabsEl.getBoundingClientRect();
        const delta = tabRect.left - scrollerRect.left - (scrollerRect.width - tabRect.width) / 2;
        tabsEl.scrollTo({
          left: Math.max(0, tabsEl.scrollLeft + delta),
          behavior: immediate || cbtPrefersReducedMotion() ? 'auto' : 'smooth'
        });
      };

      const updateUiBySlide = (immediate) => {
        activeIndex = getRealIndexBySlide(currentSlide);
        slides.forEach((slide, i) => {
          const on = i === currentSlide;
          slide.classList.toggle('is-active', on);
          slide.setAttribute('aria-hidden', on ? 'false' : 'true');
        });
        tabs.forEach((tab, i) => {
          const on = i === activeIndex;
          tab.classList.toggle('is-active', on);
          cbtSetTab(tab, on);
        });
        captions.forEach((cap, i) => {
          cap.classList.toggle('is-active', i === activeIndex);
        });
        scrollActiveTab(!!immediate);
        syncNav();
      };

      const updateTrackTranslate = (immediate, slideIndex = currentSlide) => {
        const targetX = getTargetTranslateX(slideIndex);
        if (immediate) {
          list.style.transition = 'none';
          list.style.transform = `translate3d(${targetX}px, 0, 0)`;
          void list.offsetWidth;
          list.style.removeProperty('transition');
          list.style.willChange = 'auto';
          return;
        }
        list.style.willChange = 'transform';
        list.style.transform = `translate3d(${targetX}px, 0, 0)`;
      };

      const snapLoopIfNeeded = () => {
        if (!loopEnabled) return;
        if (currentSlide >= realCount * 2) {
          currentSlide -= realCount;
          updateTrackTranslate(true, currentSlide);
          updateUiBySlide(true);
          return;
        }
        if (currentSlide < realCount) {
          currentSlide += realCount;
          updateTrackTranslate(true, currentSlide);
          updateUiBySlide(true);
        }
      };

      const activateByRealIndex = (idx, immediate) => {
        const safeIdx = Math.max(0, Math.min(idx, realCount - 1));
        currentSlide = loopEnabled ? safeIdx + realCount : safeIdx;
        updateUiBySlide(immediate);
        updateTrackTranslate(immediate, currentSlide);
      };

      const shiftSlide = (delta) => {
        if (!loopEnabled) {
          currentSlide = Math.max(0, Math.min(currentSlide + delta, realCount - 1));
        } else {
          currentSlide += delta;
        }
        updateUiBySlide(false);
        updateTrackTranslate(cbtPrefersReducedMotion(), currentSlide);
        if (cbtPrefersReducedMotion()) snapLoopIfNeeded();
      };

      const onTrackTransitionEnd = (ev) => {
        if (ev.target !== list || ev.propertyName !== 'transform') return;
        list.style.willChange = 'auto';
        snapLoopIfNeeded();
      };
      list.addEventListener('transitionend', onTrackTransitionEnd);
      cleanups.push(() => list.removeEventListener('transitionend', onTrackTransitionEnd));

      const syncProgress = (playing) => {
        section.classList.remove('is-autoplaying');
        if (!playing) return;
        void section.offsetWidth;
        section.classList.add('is-autoplaying');
      };
      const auto = bindCbtAutoplay(
        section,
        cleanups,
        () => {
          if (realCount <= 1) return;
          shiftSlide(1);
        },
        syncProgress,
        { pauseOnHover: false }
      );

      tabs.forEach((tab, idx) => {
        const onClick = () => {
          activateByRealIndex(idx, false);
          auto.restart();
        };
        tab.addEventListener('click', onClick);
        cleanups.push(() => tab.removeEventListener('click', onClick));
      });
      bindCbtRovingTabs(
        tabs,
        (idx) => {
          activateByRealIndex(idx, false);
          auto.restart();
        },
        cleanups
      );

      if (prev instanceof HTMLElement) {
        const onPrev = () => {
          shiftSlide(-1);
          auto.restart();
        };
        prev.addEventListener('click', onPrev);
        cleanups.push(() => prev.removeEventListener('click', onPrev));
      }
      if (next instanceof HTMLElement) {
        const onNext = () => {
          shiftSlide(1);
          auto.restart();
        };
        next.addEventListener('click', onNext);
        cleanups.push(() => next.removeEventListener('click', onNext));
      }

      const bindFade = (el, delta) => {
        if (!(el instanceof HTMLElement)) return;
        const onFadeClick = (e) => {
          if (el.classList.contains('is-hidden')) return;
          if (e) {
            e.preventDefault();
            e.stopPropagation();
          }
          shiftSlide(delta);
          auto.restart();
        };
        el.addEventListener('click', onFadeClick);
        cleanups.push(() => el.removeEventListener('click', onFadeClick));

        /* 箭头叠在 Tab 上，点到这片区域切页，不要选中底下的 Tab */
        const fadeWrap = el.parentElement;
        const onFadeCapture = (e) => {
          if (!(e instanceof MouseEvent) || el.classList.contains('is-hidden')) return;
          if (e.target instanceof Element && el.contains(e.target)) return;
          const rect = el.getBoundingClientRect();
          if (
            e.clientX >= rect.left &&
            e.clientX <= rect.right &&
            e.clientY >= rect.top &&
            e.clientY <= rect.bottom
          ) {
            onFadeClick(e);
          }
        };
        if (fadeWrap instanceof HTMLElement) {
          fadeWrap.addEventListener('click', onFadeCapture, true);
          cleanups.push(() => fadeWrap.removeEventListener('click', onFadeCapture, true));
        }
      };
      bindFade(fadePrevEl, -1);
      bindFade(fadeNextEl, 1);

      if (viewport instanceof HTMLElement) {
        let startX = 0;
        let startY = 0;
        const onTouchStart = (e) => {
          startX = e.changedTouches[0].clientX;
          startY = e.changedTouches[0].clientY;
        };
        const onTouchEnd = (e) => {
          const dx = e.changedTouches[0].clientX - startX;
          const dy = e.changedTouches[0].clientY - startY;
          /* 纵向位移更大就当成翻页面，不切幻灯片 */
          if (Math.abs(dx) <= 40 || Math.abs(dy) > Math.abs(dx)) return;
          shiftSlide(dx > 0 ? -1 : 1);
          auto.restart();
        };
        viewport.addEventListener('touchstart', onTouchStart, { passive: true });
        viewport.addEventListener('touchend', onTouchEnd, { passive: true });
        cleanups.push(() => {
          viewport.removeEventListener('touchstart', onTouchStart);
          viewport.removeEventListener('touchend', onTouchEnd);
        });
      }

      cbtOnResize(() => {
        updateTrackTranslate(true);
        syncNav();
      }, cleanups);

      activateByRealIndex(0, true);
      window.requestAnimationFrame(() => activateByRealIndex(0, true));
    });
  }

  /**
   * 清晰通话：三项手风琴。桌面右栏换图，手机把媒体插进当前展开项；
   * 第三项两个视频切换，默认静音可点开声。
   *
   * @param {HTMLElement} root
   * @param {{ cleanups: Array<() => void> }} ctx
   */
  function initClipbudsCalls(root, ctx) {
    const { cleanups } = ctx;
    const mobileMq =
      typeof window.matchMedia === 'function' ? window.matchMedia(MOBILE_MQ) : null;

    root.querySelectorAll('[data-cbt-calls]').forEach((section) => {
      if (!(section instanceof HTMLElement)) return;
      const stage = section.querySelector('[data-cbt-calls-stage]');
      const pane = section.querySelector('[data-cbt-calls-pane]');
      const items = Array.from(section.querySelectorAll('[data-cbt-calls-item]'));
      const panels = Array.from(section.querySelectorAll('[data-cbt-calls-panel]'));
      if (!(stage instanceof HTMLElement) || !(pane instanceof HTMLElement) || !items.length) {
        return;
      }

      let index = Math.max(
        0,
        items.findIndex((item) => item.classList.contains('is-active'))
      );
      if (index < 0) index = 0;
      let videoIndex = 0;
      let muted = true;

      const videos = Array.from(section.querySelectorAll('[data-cbt-calls-video]'));

      /* Safari 会忽略 video 里的 source media，按断点自己选片和封面 */
      const ensureVideoSource = (video) => {
        if (!(video instanceof HTMLVideoElement)) return;
        const mobile = !!(mobileMq && mobileMq.matches);
        const src =
          (mobile ? video.getAttribute('data-cbt-src-mo') : video.getAttribute('data-cbt-src-pc')) ||
          video.getAttribute('data-cbt-src-pc') ||
          '';
        const poster =
          (mobile ? video.getAttribute('data-cbt-poster-mo') : video.getAttribute('data-cbt-poster-pc')) ||
          video.getAttribute('data-cbt-poster-pc') ||
          '';
        if (poster) video.poster = poster;
        if (!src || video.getAttribute('src') === src) return;
        const wasPlaying = !video.paused && !video.ended;
        video.src = src;
        video.load();
        if (!wasPlaying) return;
        video.muted = muted;
        const pending = video.play();
        if (pending && typeof pending.catch === 'function') pending.catch(() => {});
      };
      const toggleWrap = section.querySelector('[data-cbt-calls-toggle]');
      const toggleThumb = section.querySelector('[data-cbt-calls-toggle-thumb]');
      const toggleBtns = Array.from(section.querySelectorAll('[data-cbt-calls-toggle-btn]'));
      const muteBtn = section.querySelector('[data-cbt-calls-mute]');
      const cap0 = section.querySelector('[data-cbt-calls-caption-0]');
      const cap1 = section.querySelector('[data-cbt-calls-caption-1]');

      const placePane = () => {
        const mobile = !!(mobileMq && mobileMq.matches);
        if (mobile) {
          const videoItem = items.find((item) => item.classList.contains('is-video'));
          const bodyInner =
            videoItem instanceof HTMLElement
              ? videoItem.querySelector('[data-cbt-calls-body-inner]')
              : null;
          if (bodyInner instanceof HTMLElement) {
            const moDesc = bodyInner.querySelector('.ug-clipbuds-template__calls-desc--mo');
            if (moDesc) moDesc.after(pane);
            else bodyInner.insertBefore(pane, bodyInner.querySelector('.ug-clipbuds-template__calls-desc'));
            return;
          }
        }
        stage.appendChild(pane);
      };

      const syncToggleThumb = () => {
        if (!(toggleWrap instanceof HTMLElement) || !(toggleThumb instanceof HTMLElement)) return;
        const activeBtn =
          toggleBtns.find((btn) => btn.classList.contains('is-active')) || toggleBtns[0];
        if (!(activeBtn instanceof HTMLElement)) return;
        const wrapRect = toggleWrap.getBoundingClientRect();
        const btnRect = activeBtn.getBoundingClientRect();
        toggleWrap.style.setProperty('--cbt-toggle-x', `${Math.max(0, btnRect.left - wrapRect.left)}px`);
        toggleWrap.style.setProperty('--cbt-toggle-w', `${btnRect.width}px`);
      };

      const pauseVideos = () => {
        videos.forEach((video) => {
          if (!(video instanceof HTMLVideoElement)) return;
          video.pause();
        });
      };

      const playActiveVideo = () => {
        videos.forEach((video) => {
          if (!(video instanceof HTMLVideoElement)) return;
          const on = video.getAttribute('data-cbt-calls-video') === String(videoIndex);
          video.muted = muted;
          video.classList.toggle('is-active', on);
          ensureVideoSource(video);
          if (on) {
            const play = video.play();
            if (play && typeof play.catch === 'function') play.catch(() => {});
            return;
          }
          video.pause();
        });
      };

      const syncVideoUi = () => {
        toggleBtns.forEach((btn) => {
          const on = btn.getAttribute('data-cbt-calls-toggle-btn') === String(videoIndex);
          btn.classList.toggle('is-active', on);
          btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        if (cap0 instanceof HTMLElement) cap0.hidden = videoIndex !== 0 || !cap0.textContent;
        if (cap1 instanceof HTMLElement) cap1.hidden = videoIndex !== 1 || !cap1.textContent;
        if (muteBtn instanceof HTMLElement) {
          muteBtn.classList.toggle('is-muted', muted);
          /* 标签描述点下去会发生什么，状态不再用 aria-pressed 重复表达 */
          muteBtn.setAttribute(
            'aria-label',
            muted ? cbtUi(root, 'data-cbt-ui-unmute', 'Unmute') : cbtUi(root, 'data-cbt-ui-mute', 'Mute')
          );
        }
        syncToggleThumb();
      };

      const activate = (nextIndex) => {
        index = Math.max(0, Math.min(nextIndex, items.length - 1));
        items.forEach((item, i) => {
          const on = i === index;
          item.classList.toggle('is-active', on);
          const trigger = item.querySelector('[data-cbt-calls-trigger]');
          if (trigger instanceof HTMLElement) {
            trigger.setAttribute('aria-expanded', on ? 'true' : 'false');
          }
        });
        panels.forEach((panel, i) => {
          const on = i === index;
          panel.classList.toggle('is-active', on);
          panel.setAttribute('aria-hidden', on ? 'false' : 'true');
        });
        placePane();
        if (panels[index] && panels[index].classList.contains('is-video')) {
          playActiveVideo();
        } else {
          pauseVideos();
        }
        window.requestAnimationFrame(syncToggleThumb);
      };

      const auto = bindCbtAutoplay(section, cleanups, () => {
        if (items.length < 2) return;
        activate((index + 1) % items.length);
      });

      items.forEach((item, i) => {
        const trigger = item.querySelector('[data-cbt-calls-trigger]');
        if (!trigger) return;
        const onClick = () => {
          if (i === index) return;
          activate(i);
          auto.restart();
        };
        trigger.addEventListener('click', onClick);
        cleanups.push(() => trigger.removeEventListener('click', onClick));
      });

      toggleBtns.forEach((btn) => {
        const onClick = () => {
          videoIndex = btn.getAttribute('data-cbt-calls-toggle-btn') === '1' ? 1 : 0;
          syncVideoUi();
          if (panels[index] && panels[index].classList.contains('is-video')) {
            playActiveVideo();
          }
        };
        btn.addEventListener('click', onClick);
        cleanups.push(() => btn.removeEventListener('click', onClick));
      });
      bindCbtRovingTabs(
        toggleBtns.filter((el) => el instanceof HTMLElement),
        (i) => {
          const btn = toggleBtns[i];
          if (!(btn instanceof HTMLElement)) return;
          videoIndex = btn.getAttribute('data-cbt-calls-toggle-btn') === '1' ? 1 : 0;
          syncVideoUi();
          if (panels[index] && panels[index].classList.contains('is-video')) playActiveVideo();
        },
        cleanups
      );

      if (muteBtn instanceof HTMLElement) {
        const onMute = () => {
          muted = !muted;
          videos.forEach((video) => {
            if (video instanceof HTMLVideoElement) video.muted = muted;
          });
          syncVideoUi();
        };
        muteBtn.addEventListener('click', onMute);
        cleanups.push(() => muteBtn.removeEventListener('click', onMute));
      }

      cbtOnResize(() => {
        placePane();
        syncToggleThumb();
      }, cleanups);
      const onVideoMq = () => {
        const showing = panels[index] && panels[index].classList.contains('is-video');
        if (showing) playActiveVideo();
        else videos.forEach((video) => ensureVideoSource(video));
      };
      cbtOnMqChange(mobileMq, onVideoMq, cleanups);
      cleanups.push(pauseVideos);

      syncVideoUi();
      activate(index);
      window.requestAnimationFrame(syncToggleThumb);
    });
  }

  /**
   * 细节轮播：跟 Magflow dur-carousel 同一套。
   * 电脑端左右按钮一次滑到头或尾，手机端一次移动一张。
   *
   * @param {HTMLElement} root
   * @param {{ cleanups: Array<() => void> }} ctx
   */
  function initClipbudsDetail(root, ctx) {
    const { cleanups } = ctx;
    const sections = root.querySelectorAll('[data-cbt-detail]');
    if (!sections.length) return;

    const DESKTOP_MQ = '(min-width: 1024px)';
    const isDesktop = () =>
      typeof window.matchMedia === 'function' && window.matchMedia(DESKTOP_MQ).matches;

    const instances = [];
    sections.forEach((section) => {
      if (!(section instanceof HTMLElement)) return;
      const el = section.querySelector('[data-cbt-detail-swiper]');
      if (!(el instanceof HTMLElement)) return;
      instances.push({
        section,
        el,
        prev: section.querySelector('[data-cbt-detail-prev]'),
        next: section.querySelector('[data-cbt-detail-next]'),
        progressFill: section.querySelector('[data-cbt-detail-progress-fill]'),
        swiper: null,
        onPrev: null,
        onNext: null
      });
    });
    if (!instances.length) return;

    let swiperWait = 0;

    const syncNav = (inst) => {
      const sw = inst.swiper;
      if (!sw) return;
      const start = sw.minTranslate();
      const end = sw.maxTranslate();
      const t = sw.translate;
      const atStart = t >= start - 1;
      const atEnd = t <= end + 1;
      if (inst.prev instanceof HTMLElement) {
        inst.prev.classList.toggle('swiper-button-disabled', atStart);
        inst.prev.toggleAttribute('disabled', atStart);
      }
      if (inst.next instanceof HTMLElement) {
        inst.next.classList.toggle('swiper-button-disabled', atEnd);
        inst.next.toggleAttribute('disabled', atEnd);
      }
    };

    const syncProgress = (inst) => {
      if (!(inst.progressFill instanceof HTMLElement)) return;
      const total = inst.el.querySelectorAll('.swiper-slide').length || 1;
      const sw = inst.swiper;
      if (!sw) {
        inst.progressFill.style.width = `${(1 / total) * 100}%`;
        return;
      }
      const start = sw.minTranslate();
      const end = sw.maxTranslate();
      const p = end === start ? 1 : (start - sw.translate) / (start - end);
      const ratio = Math.min(1, Math.max(0, p));
      inst.progressFill.style.width = `${((1 / total + ratio * (1 - 1 / total)) * 100).toFixed(2)}%`;
    };

    /* 电脑端允许邻卡探出轮播，卡片保持不透明 */
    const syncPeek = (inst) => {
      inst.section.classList.toggle('is-cbt-detail-peek', isDesktop());
    };

    const markNative = (inst) => {
      inst.el.classList.add('is-cbt-detail-native');
      inst.section.classList.remove('is-cbt-detail-peek');
    };

    const getStep = (sw) => {
      const slide = sw.slides && sw.slides[0];
      const width = slide instanceof HTMLElement ? slide.offsetWidth : 0;
      const gap = Number(sw.params.spaceBetween) || 0;
      return width + gap;
    };

    const animateTo = (inst, translate) => {
      const sw = inst.swiper;
      if (!sw) return;
      const speed = cbtPrefersReducedMotion() ? 0 : Number(sw.params.speed) || CBT_MOTION.slideMs;
      const target = Math.max(sw.maxTranslate(), Math.min(sw.minTranslate(), translate));
      sw.setTransition(speed);
      sw.setTranslate(target);
      sw.updateProgress();
      sw.updateActiveIndex();
      sw.updateSlidesClasses();
      syncNav(inst);
      syncProgress(inst);
      syncPeek(inst);
    };

    /* 每次前进一张；到末尾回到第一张。电脑端按钮仍是一次滑到头或尾 */
    const advanceDetail = (inst) => {
      const slides = inst.el.querySelectorAll('.swiper-slide');
      if (slides.length <= 1) return;
      const sw = inst.swiper;
      if (!sw) {
        if (!inst.el.classList.contains('is-cbt-detail-native')) return;
        const slide = slides[0];
        const width = slide instanceof HTMLElement ? slide.offsetWidth : inst.el.clientWidth;
        const max = inst.el.scrollWidth - inst.el.clientWidth;
        const nextLeft = inst.el.scrollLeft >= max - 1 ? 0 : Math.min(max, inst.el.scrollLeft + width);
        inst.el.scrollTo({ left: nextLeft, behavior: cbtPrefersReducedMotion() ? 'auto' : 'smooth' });
        return;
      }
      const start = sw.minTranslate();
      const end = sw.maxTranslate();
      if (sw.translate <= end + 1) {
        animateTo(inst, start);
        return;
      }
      animateTo(inst, Math.max(end, sw.translate - getStep(sw)));
    };

    const destroyOne = (inst) => {
      if (inst.prev instanceof HTMLElement && inst.onPrev) {
        inst.prev.removeEventListener('click', inst.onPrev);
      }
      if (inst.next instanceof HTMLElement && inst.onNext) {
        inst.next.removeEventListener('click', inst.onNext);
      }
      inst.onPrev = null;
      inst.onNext = null;
      if (inst.swiper) {
        try {
          inst.swiper.destroy(true, true);
        } catch (_) {}
        inst.swiper = null;
      }
      inst.section.classList.remove('is-cbt-detail-peek');
    };

    const mountOne = (inst) => {
      if (typeof window.Swiper !== 'function') return;
      destroyOne(inst);
      if (!inst.el.querySelectorAll('.swiper-slide').length) return;
      try {
        inst.el.classList.remove('is-cbt-detail-native');
        inst.swiper = new window.Swiper(inst.el, {
          slidesPerView: 'auto',
          spaceBetween: 20,
          slidesPerGroup: 1,
          watchOverflow: false,
          observer: true,
          observeParents: true,
          roundLengths: true,
          preventClicks: false,
          preventClicksPropagation: false,
          speed: cbtPrefersReducedMotion() ? 0 : CBT_MOTION.slideMs,
          breakpoints: {
            0: { spaceBetween: 0 },
            1024: { spaceBetween: 20 }
          },
          on: {
            init() {
              syncNav(inst);
              syncProgress(inst);
              syncPeek(inst);
            },
            resize() {
              syncNav(inst);
              syncProgress(inst);
              syncPeek(inst);
            },
            transitionEnd() {
              syncNav(inst);
              syncProgress(inst);
              syncPeek(inst);
            },
            touchStart() {
              if (typeof inst.holdAuto === 'function') inst.holdAuto();
            },
            touchEnd() {
              if (typeof inst.restartAuto === 'function') inst.restartAuto();
            }
          }
        });
        inst.onPrev = (e) => {
          e.preventDefault();
          const sw = inst.swiper;
          if (!sw) return;
          const start = sw.minTranslate();
          if (sw.translate >= start - 1) return;
          if (isDesktop()) {
            animateTo(inst, start);
            if (typeof inst.restartAuto === 'function') inst.restartAuto();
            return;
          }
          animateTo(inst, Math.min(start, sw.translate + getStep(sw)));
          if (typeof inst.restartAuto === 'function') inst.restartAuto();
        };
        inst.onNext = (e) => {
          e.preventDefault();
          const sw = inst.swiper;
          if (!sw) return;
          const end = sw.maxTranslate();
          if (sw.translate <= end + 1) return;
          if (isDesktop()) {
            animateTo(inst, end);
            if (typeof inst.restartAuto === 'function') inst.restartAuto();
            return;
          }
          animateTo(inst, Math.max(end, sw.translate - getStep(sw)));
          if (typeof inst.restartAuto === 'function') inst.restartAuto();
        };
        if (inst.prev instanceof HTMLElement) inst.prev.addEventListener('click', inst.onPrev);
        if (inst.next instanceof HTMLElement) inst.next.addEventListener('click', inst.onNext);
        window.requestAnimationFrame(() => {
          if (!inst.swiper) return;
          inst.swiper.update();
          syncNav(inst);
          syncProgress(inst);
          syncPeek(inst);
        });
      } catch (_) {
        markNative(inst);
      }
    };

    instances.forEach((inst) => {
      const auto = bindCbtAutoplay(inst.section, cleanups, () => advanceDetail(inst));
      inst.restartAuto = auto.restart;
      inst.holdAuto = auto.hold;
    });

    const mount = () => instances.forEach(mountOne);
    if (typeof window.Swiper === 'function') {
      mount();
    } else {
      /* Swiper 一挂上就把兜底的等待计时清掉，别让它空转到 10 秒 */
      let waitMax = 0;
      const stopWaiting = () => {
        if (swiperWait) {
          clearInterval(swiperWait);
          swiperWait = 0;
        }
        if (waitMax) {
          clearTimeout(waitMax);
          waitMax = 0;
        }
      };
      swiperWait = window.setInterval(() => {
        if (typeof window.Swiper !== 'function') return;
        stopWaiting();
        mount();
      }, CBT_MOTION.swiperPollMs);
      waitMax = window.setTimeout(() => {
        stopWaiting();
        instances.forEach((inst) => {
          if (!inst.swiper) markNative(inst);
        });
      }, 10000);
      cleanups.push(stopWaiting);
    }
    cleanups.push(() => {
      if (swiperWait) clearInterval(swiperWait);
      instances.forEach(destroyOne);
    });
  }

  /**
   * watch / youtu.be / embed / shorts / live 都认，其它地址当文件。
   *
   * @param {string} url
   * @returns {string}
   */
  function cbtYouTubeId(url) {
    if (!url || typeof url !== 'string') return '';
    let parsed;
    try {
      parsed = new URL(url.trim());
    } catch (e) {
      return '';
    }
    const host = parsed.hostname.replace(/^www\./, '').toLowerCase();
    if (host === 'youtu.be') {
      return decodeURIComponent((parsed.pathname.split('/').filter(Boolean)[0] || '').split('&')[0]);
    }
    if (
      host !== 'youtube.com' &&
      host !== 'm.youtube.com' &&
      host !== 'music.youtube.com' &&
      host !== 'youtube-nocookie.com'
    ) {
      return '';
    }
    const fromQuery = parsed.searchParams.get('v');
    if (fromQuery) return fromQuery;
    const parts = parsed.pathname.split('/').filter(Boolean);
    const marker = parts.findIndex((part) => part === 'embed' || part === 'shorts' || part === 'live' || part === 'v');
    if (marker >= 0 && parts[marker + 1]) return parts[marker + 1];
    return '';
  }

  /**
   * 使用视频：默认静音播放，左下静音、右下暂停。
   * mp4 走 video；YouTube 链接走 iframe，按钮用 postMessage 控制。
   *
   * @param {HTMLElement} root
   * @param {{ cleanups: Array<() => void> }} ctx
   */
  function initClipbudsGuide(root, ctx) {
    const { cleanups } = ctx;
    const uiMute = cbtUi(root, 'data-cbt-ui-mute', 'Mute');
    const uiUnmute = cbtUi(root, 'data-cbt-ui-unmute', 'Unmute');
    const uiPlay = cbtUi(root, 'data-cbt-ui-play', 'Play');
    const uiPause = cbtUi(root, 'data-cbt-ui-pause', 'Pause');
    const mobileMq = window.matchMedia(MOBILE_MQ);

    root.querySelectorAll('[data-cbt-guide]').forEach((section) => {
      if (!(section instanceof HTMLElement)) return;
      const video = section.querySelector('[data-cbt-guide-video]');
      const embed = section.querySelector('[data-cbt-guide-embed]');
      const stage = section.querySelector('.ug-clipbuds-template__guide-stage');
      const muteBtn = section.querySelector('[data-cbt-guide-mute]');
      const playBtn = section.querySelector('[data-cbt-guide-play]');
      if (!(video instanceof HTMLVideoElement) || !(stage instanceof HTMLElement)) return;

      /* 用户暂停后，滚回来不要自动接着播 */
      let userPaused = false;
      let inView = false;
      let usingYoutube = false;
      let ytMuted = true;
      let ytReady = false;
      /** @type {string[]} */
      let ytPending = [];

      const ytCmd = (func) => {
        if (!(embed instanceof HTMLIFrameElement) || !embed.contentWindow) return;
        if (!ytReady) {
          ytPending.push(func);
          return;
        }
        embed.contentWindow.postMessage(JSON.stringify({ event: 'command', func, args: [] }), '*');
      };

      if (embed instanceof HTMLIFrameElement) {
        const onEmbedLoad = () => {
          if (!usingYoutube) return;
          ytReady = true;
          const queued = ytPending.splice(0);
          queued.forEach((func) => ytCmd(func));
        };
        embed.addEventListener('load', onEmbedLoad);
        cleanups.push(() => embed.removeEventListener('load', onEmbedLoad));
      }

      const syncUi = () => {
        const muted = usingYoutube ? ytMuted : video.muted;
        const playing = usingYoutube ? !userPaused && inView : !video.paused && !video.ended;
        /* 标签描述点下去会发生什么，状态不再用 aria-pressed 重复表达 */
        if (muteBtn instanceof HTMLElement) {
          muteBtn.classList.toggle('is-muted', muted);
          muteBtn.setAttribute('aria-label', muted ? uiUnmute : uiMute);
        }
        if (playBtn instanceof HTMLElement) {
          playBtn.classList.toggle('is-playing', playing);
          playBtn.setAttribute('aria-label', playing ? uiPause : uiPlay);
        }
      };

      const resolvedSrc = () => {
        const mobile = mobileMq.matches;
        return (
          (mobile ? video.getAttribute('data-cbt-src-mo') : video.getAttribute('data-cbt-src-pc')) ||
          video.getAttribute('data-cbt-src-pc') ||
          ''
        );
      };

      const resolvedPoster = () => {
        const mobile = mobileMq.matches;
        return (
          (mobile ? video.getAttribute('data-cbt-poster-mo') : video.getAttribute('data-cbt-poster-pc')) ||
          video.getAttribute('data-cbt-poster-pc') ||
          ''
        );
      };

      const showFile = () => {
        usingYoutube = false;
        ytReady = false;
        ytPending = [];
        stage.classList.remove('is-embed');
        if (embed instanceof HTMLIFrameElement && embed.getAttribute('src')) {
          embed.removeAttribute('src');
          embed.hidden = true;
        }
      };

      const showYoutube = (id) => {
        usingYoutube = true;
        stage.classList.add('is-embed');
        video.pause();
        if (video.getAttribute('src')) {
          video.removeAttribute('src');
          video.load();
        }
        if (!(embed instanceof HTMLIFrameElement)) return;
        const params = new URLSearchParams({
          autoplay: '1',
          mute: '1',
          loop: '1',
          playlist: id,
          playsinline: '1',
          rel: '0',
          modestbranding: '1',
          controls: '0',
          enablejsapi: '1',
          origin: window.location.origin
        });
        const next = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?' + params.toString();
        if (embed.getAttribute('src') !== next) {
          ytMuted = true;
          ytReady = false;
          ytPending = [];
          embed.src = next;
        }
        embed.hidden = false;
      };

      /* video 的 source media 在 Safari 里会被忽略，按断点自己选片；YouTube 不进 video.src */
      const applySource = () => {
        const src = resolvedSrc();
        const poster = resolvedPoster();
        const youtubeId = cbtYouTubeId(src);
        if (youtubeId) {
          if (poster) video.poster = poster;
          showYoutube(youtubeId);
          return;
        }
        showFile();
        if (poster) video.poster = poster;
        if (!src || video.getAttribute('src') === src) return;
        const resume = inView && !userPaused && !video.paused;
        video.src = src;
        video.load();
        if (resume) {
          video.muted = true;
          const pending = video.play();
          if (pending && typeof pending.catch === 'function') pending.catch(() => {});
        }
      };

      const tryPlay = () => {
        if (userPaused) return;
        applySource();
        if (usingYoutube) {
          ytCmd('playVideo');
          if (ytMuted) ytCmd('mute');
          syncUi();
          return;
        }
        video.muted = true;
        const pending = video.play();
        if (pending && typeof pending.catch === 'function') pending.catch(() => {});
        syncUi();
      };

      const pauseActive = () => {
        if (usingYoutube) ytCmd('pauseVideo');
        else video.pause();
        syncUi();
      };

      if (muteBtn instanceof HTMLElement) {
        const onMute = () => {
          if (usingYoutube) {
            ytMuted = !ytMuted;
            ytCmd(ytMuted ? 'mute' : 'unMute');
            syncUi();
            return;
          }
          video.muted = !video.muted;
          syncUi();
        };
        muteBtn.addEventListener('click', onMute);
        cleanups.push(() => muteBtn.removeEventListener('click', onMute));
      }

      if (playBtn instanceof HTMLElement) {
        const onPlay = () => {
          if (usingYoutube) {
            if (userPaused || !inView) {
              userPaused = false;
              tryPlay();
            } else {
              userPaused = true;
              ytCmd('pauseVideo');
            }
            syncUi();
            return;
          }
          if (video.paused || video.ended) {
            userPaused = false;
            tryPlay();
          } else {
            userPaused = true;
            video.pause();
          }
          syncUi();
        };
        playBtn.addEventListener('click', onPlay);
        cleanups.push(() => playBtn.removeEventListener('click', onPlay));
      }

      const onPlayState = () => syncUi();
      video.addEventListener('play', onPlayState);
      video.addEventListener('pause', onPlayState);
      syncUi();

      let observer = null;
      if (typeof IntersectionObserver === 'function') {
        observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              inView = entry.isIntersecting;
              if (entry.isIntersecting) tryPlay();
              else pauseActive();
            });
          },
          { rootMargin: '160px 0px', threshold: 0.2 }
        );
        observer.observe(section);
      } else {
        inView = true;
        tryPlay();
      }

      cbtOnMqChange(mobileMq, () => applySource(), cleanups);

      cleanups.push(() => {
        if (observer) observer.disconnect();
        video.removeEventListener('play', onPlayState);
        video.removeEventListener('pause', onPlayState);
        video.pause();
        video.removeAttribute('src');
        video.load();
        if (embed instanceof HTMLIFrameElement) {
          embed.removeAttribute('src');
          embed.hidden = true;
        }
      });
    });
  }

  /**
   * 全天续航：桌面切右侧大图，手机只展开一项。
   *
   * @param {HTMLElement} root
   * @param {{ cleanups: Array<() => void> }} ctx
   */
  function initClipbudsWorkday(root, ctx) {
    const { cleanups } = ctx;
    root.querySelectorAll('[data-cbt-workday]').forEach((section) => {
      if (!(section instanceof HTMLElement)) return;
      const items = Array.from(section.querySelectorAll('[data-cbt-workday-item]'));
      const panels = Array.from(section.querySelectorAll('[data-cbt-workday-panel]'));
      if (items.length < 2) return;

      let index = items.findIndex((item) => item.classList.contains('is-active'));
      if (index < 0) index = 0;

      const activate = (nextIndex) => {
        index = Math.max(0, Math.min(nextIndex, items.length - 1));
        items.forEach((item, i) => {
          const on = i === index;
          item.classList.toggle('is-active', on);
          const trigger = item.querySelector('[data-cbt-workday-trigger]');
          if (trigger instanceof HTMLElement) {
            trigger.setAttribute('aria-expanded', on ? 'true' : 'false');
          }
        });
        panels.forEach((panel, i) => {
          const on = i === index;
          panel.classList.toggle('is-active', on);
          panel.setAttribute('aria-hidden', on ? 'false' : 'true');
        });
      };

      const auto = bindCbtAutoplay(section, cleanups, () => {
        activate((index + 1) % items.length);
      });

      items.forEach((item, i) => {
        const trigger = item.querySelector('[data-cbt-workday-trigger]');
        if (!trigger) return;
        const onClick = () => {
          if (i === index) return;
          activate(i);
          auto.restart();
        };
        trigger.addEventListener('click', onClick);
        cleanups.push(() => trigger.removeEventListener('click', onClick));
      });
    });
  }

  /**
   * 全天舒适：手机手风琴同时只开一项，桌面三卡常开。
   *
   * @param {HTMLElement} root
   * @param {{ cleanups: Array<() => void> }} ctx
   */
  function initClipbudsComfort(root, ctx) {
    const { cleanups } = ctx;
    root.querySelectorAll('[data-cbt-comfort]').forEach((section) => {
      if (!(section instanceof HTMLElement)) return;
      const items = Array.from(section.querySelectorAll('[data-cbt-comfort-item]'));
      if (items.length < 2) return;

      let index = items.findIndex((item) => item.classList.contains('is-active'));
      if (index < 0) index = 0;

      const activate = (nextIndex) => {
        index = Math.max(0, Math.min(nextIndex, items.length - 1));
        items.forEach((item, i) => {
          const on = i === index;
          item.classList.toggle('is-active', on);
          const trigger = item.querySelector('[data-cbt-comfort-trigger]');
          if (trigger instanceof HTMLElement) {
            trigger.setAttribute('aria-expanded', on ? 'true' : 'false');
          }
        });
      };

      const mobileMq =
        typeof window.matchMedia === 'function' ? window.matchMedia(MOBILE_MQ) : null;
      /* 桌面三卡常开，只在手机手风琴时轮换；桌面端根本不起计时，别每 5 秒空转一次 */
      const auto = bindCbtAutoplay(
        section,
        cleanups,
        () => {
          activate((index + 1) % items.length);
        },
        undefined,
        { enabled: () => !mobileMq || mobileMq.matches }
      );
      cbtOnMqChange(mobileMq, auto.restart, cleanups);

      items.forEach((item, i) => {
        const trigger = item.querySelector('[data-cbt-comfort-trigger]');
        if (!trigger) return;
        const onClick = () => {
          if (i === index) return;
          activate(i);
          auto.restart();
        };
        trigger.addEventListener('click', onClick);
        cleanups.push(() => trigger.removeEventListener('click', onClick));
      });
    });
  }

  /**
   * 静态色块：按配置的 2–3 个变体交叉淡入淡出底图，不碰商品变体。
   *
   * @param {HTMLElement} root
   * @param {{ cleanups: Array<() => void> }} ctx
   */
  function initClipbudsEditionsVariants(root, ctx) {
    const { cleanups } = ctx;
    const onClick = (e) => {
      const btn = e.target instanceof Element ? e.target.closest('[data-cbt-variant]') : null;
      if (!btn || !root.contains(btn)) return;
      if (btn.classList.contains('is-active')) return;
      const card = btn.closest('[data-cbt-editions-card]');
      if (!(card instanceof HTMLElement)) return;
      const key = btn.getAttribute('data-cbt-variant') || '';
      card.querySelectorAll('[data-cbt-bg-layer]').forEach((el) => {
        el.classList.toggle('is-visible', el.getAttribute('data-cbt-bg-layer') === key);
      });
      card.querySelectorAll('[data-cbt-variant]').forEach((el) => {
        const on = el === btn;
        el.classList.toggle('is-active', on);
        el.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    };
    root.addEventListener('click', onClick);
    cleanups.push(() => root.removeEventListener('click', onClick));
  }

  /**
   * 产品卡优惠码复制。
   *
   * @param {HTMLElement} root
   * @param {{ cleanups: Array<() => void> }} ctx
   */
  function initClipbudsEditionsCodeCopy(root, ctx) {
    const { cleanups } = ctx;
    const copyTimers = [];
    const onClick = (e) => {
      const btn =
        e.target instanceof Element ? e.target.closest('[data-cbt-editions-code-copy]') : null;
      if (!btn || !root.contains(btn)) return;
      const code = btn.getAttribute('data-code');
      if (!code) return;
      const copiedText = btn.getAttribute('data-copied-text');
      const copyText = btn.getAttribute('data-copy-text');
      cbtCopyText(code, () => {
        if (copiedText) btn.textContent = copiedText;
        const timer = window.setTimeout(() => {
          if (copyText) btn.textContent = copyText;
        }, 2000);
        copyTimers.push(timer);
      });
    };
    root.addEventListener('click', onClick);
    cleanups.push(() => {
      root.removeEventListener('click', onClick);
      copyTimers.forEach((id) => window.clearTimeout(id));
    });
  }

  /**
   * 等 GSAP / ScrollTrigger 就绪；超时则走无动效兜底。
   *
   * @param {(ok: boolean) => void} cb
   * @param {number} [timeoutMs]
   */
  function whenGsapReady(cb, timeoutMs) {
    let settled = false;
    const finish = (ok) => {
      if (settled) return;
      settled = true;
      cb(ok);
    };
    if (window.gsap && window.ScrollTrigger) {
      finish(true);
      return () => {};
    }
    const started = Date.now();
    const timer = window.setInterval(() => {
      if (window.gsap && window.ScrollTrigger) {
        window.clearInterval(timer);
        finish(true);
        return;
      }
      if (Date.now() - started > (timeoutMs || 2500)) {
        window.clearInterval(timer);
        finish(false);
      }
    }, 80);
    return () => {
      settled = true;
      window.clearInterval(timer);
    };
  }

  let cbtRefreshRaf = 0;

  /* 多处改布局时合并到下一帧再 refresh，避免同帧重复计算 */
  function scheduleCbtScrollTriggerRefresh() {
    const ScrollTrigger = window.ScrollTrigger;
    if (!ScrollTrigger || typeof ScrollTrigger.refresh !== 'function') return;
    if (cbtRefreshRaf) return;
    cbtRefreshRaf = window.requestAnimationFrame(() => {
      cbtRefreshRaf = 0;
      try {
        ScrollTrigger.refresh();
      } catch (_) {}
    });
  }

  /* refresh 把 tween 打回 0 时钉在终态，避免模块被重新藏掉。不要 play(0)。 */
  function cbtGuardRevealOnRefresh(self) {
    const anim = self && self.animation;
    if (!anim || self.progress <= 0 || anim.progress() > 0) return;
    anim.progress(1);
  }

  /* 不是从页顶进来：视口上方（已滚过）或当前看得见的，直接终态 */
  function cbtRevealShouldSnapToEnd(el) {
    if (!(el instanceof HTMLElement)) return false;
    if ((window.scrollY || 0) <= 80) return false;
    const rect = el.getBoundingClientRect();
    const vh = window.innerHeight || 0;
    if (rect.bottom <= 0) return true;
    return rect.top < vh && rect.bottom > 0;
  }

  function onCbtRevealComplete(el) {
    if (el instanceof HTMLElement) el.dataset.cbtRevealDone = '1';
  }

  /**
   * stagger 根下最外层 `data-cbt-reveal`，避免嵌套重复播。
   *
   * @param {HTMLElement} staggerRoot
   * @returns {HTMLElement[]}
   */
  function collectCbtStaggerRevealElements(staggerRoot) {
    if (!(staggerRoot instanceof HTMLElement)) return [];
    /** @type {HTMLElement[]} */
    const out = [];
    staggerRoot.querySelectorAll(':scope [data-cbt-reveal]').forEach((el) => {
      if (!(el instanceof HTMLElement)) return;
      let p = el.parentElement;
      while (p && p !== staggerRoot) {
        if (p.hasAttribute('data-cbt-reveal')) return;
        p = p.parentElement;
      }
      if (p === staggerRoot) out.push(el);
    });
    return out;
  }

  /**
   * 减少动态 / 无 GSAP 时直接终态。
   *
   * @param {HTMLElement} root
   */
  function showCbtRevealEndState(root) {
    root.querySelectorAll('[data-cbt-reveal]').forEach((el) => {
      if (!(el instanceof HTMLElement)) return;
      el.style.opacity = '1';
      el.style.transform = 'none';
    });
  }

  /**
   * 全局滚动淡入：只播一次。中部刷新直接终态，refresh 不 play(0)。
   *
   * @param {HTMLElement} root
   * @param {{ cleanups: Array<() => void>, reduced: boolean, hasGsap: boolean }} ctx
   */
  function initClipbudsScrollReveal(root, ctx) {
    const { cleanups, reduced, hasGsap } = ctx;
    const gsap = window.gsap;
    const ScrollTrigger = window.ScrollTrigger;

    if (reduced || !hasGsap || !gsap || !ScrollTrigger) {
      root.removeAttribute('data-cbt-reveal-armed');
      showCbtRevealEndState(root);
      return;
    }

    gsap.registerPlugin(ScrollTrigger);
    /* armed 由服务端打好，这里只是告诉页内守卫「主脚本接管了，别拆」 */
    root.setAttribute('data-cbt-reveal-armed', '');
    root.setAttribute('data-cbt-reveal-ready', '');

    const fromVars = { opacity: 0, y: CBT_REVEAL.y };
    const { duration, ease, start, stagger } = CBT_REVEAL;
    /** @type {Array<{ kill?: () => void }>} */
    const registered = [];

    const snapRevealEl = (el) => {
      gsap.set(el, { opacity: 1, y: 0 });
      onCbtRevealComplete(el);
    };

    const track = (tween) => {
      if (tween && tween.scrollTrigger) registered.push(tween.scrollTrigger);
    };

    const revealTriggerVars = (triggerEl) => ({
      trigger: triggerEl,
      start,
      once: true,
      toggleActions: 'play none none none',
      onRefresh: cbtGuardRevealOnRefresh
    });

    root.querySelectorAll('[data-cbt-reveal-stagger]').forEach((staggerRoot) => {
      if (!(staggerRoot instanceof HTMLElement)) return;
      const children = collectCbtStaggerRevealElements(staggerRoot);
      if (!children.length) return;
      if (cbtRevealShouldSnapToEnd(staggerRoot)) {
        children.forEach((child) => snapRevealEl(child));
        staggerRoot.dataset.cbtRevealDone = '1';
        return;
      }

      const tl = gsap.timeline({
        scrollTrigger: revealTriggerVars(staggerRoot),
        onComplete: () => {
          staggerRoot.dataset.cbtRevealDone = '1';
        }
      });
      if (tl.scrollTrigger) registered.push(tl.scrollTrigger);

      children.forEach((child, index) => {
        gsap.set(child, fromVars);
        tl.to(
          child,
          {
            opacity: 1,
            y: 0,
            duration,
            ease,
            onComplete: () => {
              onCbtRevealComplete(child);
            }
          },
          index * stagger
        );
      });
    });

    root.querySelectorAll('[data-cbt-reveal]').forEach((el) => {
      if (!(el instanceof HTMLElement)) return;
      if (el.closest('[data-cbt-reveal-stagger]')) return;

      if (cbtRevealShouldSnapToEnd(el)) {
        snapRevealEl(el);
        return;
      }

      gsap.set(el, fromVars);
      const tween = gsap.to(el, {
        opacity: 1,
        y: 0,
        duration,
        ease,
        onComplete: () => {
          onCbtRevealComplete(el);
        },
        scrollTrigger: revealTriggerVars(el)
      });
      track(tween);
    });

    initClipbudsGrammyExit(root, { cleanups, reduced });
    initClipbudsComfortFloat(root, { cleanups, reduced, registered });

    scheduleCbtScrollTriggerRefresh();

    cleanups.push(() => {
      registered.forEach((st) => {
        try {
          if (st && typeof st.kill === 'function') st.kill();
        } catch (_) {}
      });
      root.removeAttribute('data-cbt-reveal-armed');
      root.removeAttribute('data-cbt-reveal-ready');
    });
  }

  /**
   * 电脑端：格莱美离开视口时文案先淡出，画面再收到版心宽度。
   *
   * @param {HTMLElement} root
   * @param {{ cleanups: Array<() => void>, reduced: boolean }} ctx
   */
  function initClipbudsGrammyExit(root, ctx) {
    const { cleanups, reduced } = ctx;
    if (reduced) return;
    const gsap = window.gsap;
    const ScrollTrigger = window.ScrollTrigger;
    if (!gsap || !ScrollTrigger) return;

    const mq = window.matchMedia(MOBILE_MQ);
    /** @type {Array<{ kill?: () => void }>} */
    const local = [];

    const drop = (st) => {
      if (!st || typeof st.kill !== 'function') return;
      try {
        st.kill();
      } catch (_) {}
    };

    const clearSection = (section) => {
      section.style.clipPath = '';
      section.style.willChange = '';
      section
        .querySelectorAll('.ug-clipbuds-template__grammy-head, .ug-clipbuds-template__grammy-quote')
        .forEach((el) => {
          if (!(el instanceof HTMLElement)) return;
          /* 离开电脑端时收回收缩透明度，已播完的渐入保持可见 */
          if (el.dataset.cbtRevealDone === '1' || !el.hasAttribute('data-cbt-reveal')) {
            el.style.opacity = '1';
          } else {
            el.style.opacity = '';
          }
        });
    };

    const destroy = () => {
      local.forEach(drop);
      local.length = 0;
      root.querySelectorAll('[data-cbt-grammy]').forEach((section) => {
        if (section instanceof HTMLElement) clearSection(section);
      });
    };

    const mount = () => {
      destroy();
      if (mq.matches) return;
      root.querySelectorAll('[data-cbt-grammy]').forEach((section) => {
        if (!(section instanceof HTMLElement)) return;
        const inner = section.querySelector('.ug-clipbuds-template__grammy-inner');
        const media = section.querySelector('.ug-clipbuds-template__grammy-media');
        const copy = section.querySelectorAll(
          '.ug-clipbuds-template__grammy-head, .ug-clipbuds-template__grammy-quote'
        );
        if (!(inner instanceof HTMLElement) || !(media instanceof HTMLElement)) return;

        const copyEls = Array.prototype.filter.call(copy, (el) => el instanceof HTMLElement);
        /* 不用 to(opacity:0)：渐入先把透明度写成 0，scrub 会把起点记成 0，回滚就停在看不见 */
        const st = ScrollTrigger.create({
          trigger: section,
          start: 'top top',
          end: 'bottom top',
          scrub: true,
          invalidateOnRefresh: true,
          onToggle(self) {
            section.style.willChange = self.isActive ? 'clip-path' : '';
          },
          onUpdate(self) {
            const p = self.progress;
            const fadeEnd = copyEls.length ? 0.4 : 0;
            const fade = fadeEnd > 0 ? Math.min(1, p / fadeEnd) : 0;
            copyEls.forEach((el) => {
              el.style.opacity = String(1 - fade);
            });
            const clipT = fadeEnd > 0 ? Math.max(0, (p - fadeEnd) / (1 - fadeEnd)) : p;
            const fullSide = Math.max(0, (section.offsetWidth - inner.offsetWidth) / 2);
            const side = fullSide * clipT;
            section.style.clipPath =
              side > 0.5 ? 'inset(0px ' + side + 'px 0px ' + side + 'px)' : 'inset(0px)';
          },
          onLeaveBack() {
            copyEls.forEach((el) => {
              el.style.opacity = '1';
            });
            section.style.clipPath = '';
            section.style.willChange = '';
          }
        });
        local.push(st);
      });
    };

    mount();
    const onChange = () => {
      mount();
      scheduleCbtScrollTriggerRefresh();
    };
    cbtOnMqChange(mq, onChange, cleanups);
    cleanups.push(destroy);
  }

  /**
   * 舒适区主图叠一层同尺寸图，下滚时像羽毛一样往上飘。
   *
   * @param {HTMLElement} root
   * @param {{ cleanups: Array<() => void>, reduced: boolean, registered: Array<{ kill?: () => void }> }} ctx
   */
  function initClipbudsComfortFloat(root, ctx) {
    const { cleanups, reduced, registered } = ctx;
    if (reduced) return;
    const gsap = window.gsap;
    const ScrollTrigger = window.ScrollTrigger;
    if (!gsap || !ScrollTrigger) return;

    root.querySelectorAll('[data-cbt-comfort-float]').forEach((media) => {
      if (!(media instanceof HTMLElement)) return;
      const layer = media.querySelector('.ug-clipbuds-template__comfort-hero-float');
      if (!(layer instanceof HTMLElement)) return;
      const tween = gsap.to(layer, {
        y: '-22%',
        x: 28,
        rotation: -5,
        ease: 'none',
        scrollTrigger: {
          trigger: media,
          start: 'top 80%',
          end: 'bottom 20%',
          scrub: 1.4,
          onToggle(self) {
            layer.style.willChange = self.isActive ? 'transform' : '';
          }
        }
      });
      if (tween.scrollTrigger) registered.push(tween.scrollTrigger);
      cleanups.push(() => {
        layer.style.willChange = '';
      });
    });
  }

  function initClipbudsSpecs(root, ctx) {
    const { cleanups } = ctx;
    root.querySelectorAll('[data-cbt-specs]').forEach((section) => {
      if (!(section instanceof HTMLElement)) return;
      const btn = section.querySelector('[data-cbt-specs-more]');
      const label = section.querySelector('[data-cbt-specs-more-label]');
      if (!(btn instanceof HTMLButtonElement)) return;
      const moreText = label instanceof HTMLElement ? label.getAttribute('data-more') || '' : '';
      const lessText = label instanceof HTMLElement ? label.getAttribute('data-less') || '' : '';
      const onClick = () => {
        const open = section.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (label instanceof HTMLElement) label.textContent = open ? lessText : moreText;
      };
      btn.addEventListener('click', onClick);
      cleanups.push(() => btn.removeEventListener('click', onClick));
    });
  }

  function isValidClipbudsEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(email);
  }

  function bindClipbudsEmail(block, cleanups) {
    if (!(block instanceof HTMLElement) || block.dataset.cbtEmailInited === '1') return;
    const submitBtn = block.querySelector('.ug-clipbuds-template__signup-submit');
    const input = block.querySelector('.ug-clipbuds-template__signup-input');
    const errorMsg = block.querySelector('.ug-clipbuds-template__signup-error');
    const successMsg = block.querySelector('.ug-clipbuds-template__signup-message');
    if (!(submitBtn instanceof HTMLButtonElement) || !(input instanceof HTMLInputElement)) return;
    if (!(errorMsg instanceof HTMLElement) || !(successMsg instanceof HTMLElement)) return;
    block.dataset.cbtEmailInited = '1';

    const privacyCheckbox = block.querySelector('.ug-clipbuds-template__signup-checkbox');
    let abortCtrl = null;
    let submitTimer = 0;
    let abortedByTimeout = false;
    const formId = block.getAttribute('data-form-id') || '';
    const successText = block.getAttribute('data-success-text') || '';
    const failText = block.getAttribute('data-fail-text') || '';
    const privacyError = block.getAttribute('data-privacy-error') || '';
    const emailError = block.getAttribute('data-email-error') || '';
    const desktopMq = window.matchMedia('(min-width: 1024px)');

    const syncPlaceholder = () => {
      const next = desktopMq.matches
        ? input.getAttribute('data-placeholder-pc')
        : input.getAttribute('data-placeholder-mo');
      if (next) input.placeholder = next;
    };

    const showError = (msg) => {
      errorMsg.textContent = msg;
      errorMsg.style.display = 'block';
      successMsg.style.display = 'none';
    };

    const showSuccess = (msg) => {
      successMsg.textContent = msg;
      successMsg.style.display = 'block';
      errorMsg.style.display = 'none';
    };

    const trackSubscription = (isSuccess) => {
      const track = window.ugGa4Track;
      if (!track || typeof track.subscriptionEvent !== 'function') return;
      try {
        track.subscriptionEvent({ isSuccess, position: 'clipbuds-template' });
      } catch (_) {}
    };

    const onSubmit = async () => {
      if (submitBtn.classList.contains('loading')) return;
      const email = input.value.trim();
      if (!isValidClipbudsEmail(email)) {
        showError(emailError);
        return;
      }
      if (privacyCheckbox instanceof HTMLInputElement && !privacyCheckbox.checked) {
        showError(privacyError);
        return;
      }

      errorMsg.style.display = 'none';
      successMsg.style.display = 'none';
      submitBtn.classList.add('loading');
      submitBtn.setAttribute('aria-busy', 'true');

      try {
        abortCtrl = new AbortController();
        abortedByTimeout = false;
        window.clearTimeout(submitTimer);
        submitTimer = window.setTimeout(() => {
          abortedByTimeout = true;
          if (abortCtrl) abortCtrl.abort();
        }, 12000);
        const response = await fetch(CBT_FORM_SUBMIT_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          signal: abortCtrl.signal,
          body: JSON.stringify({
            email,
            accepts_marketing: privacyCheckbox instanceof HTMLInputElement && privacyCheckbox.checked ? 'on' : 'off',
            form_id: formId
          })
        });

        let data = null;
        try {
          data = await response.json();
        } catch (_) {
          showError(failText);
          trackSubscription(false);
          return;
        }

        const isSuccess = data && data.status === 'success';
        if (isSuccess) {
          input.value = '';
          if (privacyCheckbox instanceof HTMLInputElement) privacyCheckbox.checked = false;
          showSuccess(successText);
        } else {
          const serverMsg =
            (data && data.errors && data.errors.email && data.errors.email[0]) ||
            (data && data.message) ||
            failText;
          showError(serverMsg);
        }
        trackSubscription(!!isSuccess);
      } catch (err) {
        if (err && err.name === 'AbortError' && !abortedByTimeout) return;
        showError(failText);
        trackSubscription(false);
      } finally {
        window.clearTimeout(submitTimer);
        submitBtn.classList.remove('loading');
        submitBtn.removeAttribute('aria-busy');
      }
    };

    const onKeydown = (e) => {
      if (e.key !== 'Enter') return;
      e.preventDefault();
      onSubmit();
    };

    syncPlaceholder();
    submitBtn.addEventListener('click', onSubmit);
    input.addEventListener('keydown', onKeydown);
    cbtOnMqChange(desktopMq, syncPlaceholder, cleanups);

    cleanups.push(() => {
      window.clearTimeout(submitTimer);
      if (abortCtrl) abortCtrl.abort();
      submitBtn.removeEventListener('click', onSubmit);
      input.removeEventListener('keydown', onKeydown);
      if (typeof desktopMq.removeEventListener === 'function') desktopMq.removeEventListener('change', onMq);
      submitBtn.classList.remove('loading');
      submitBtn.removeAttribute('aria-busy');
      delete block.dataset.cbtEmailInited;
    });
  }

  function initClipbudsSignup(root, ctx) {
    const { cleanups } = ctx;
    root.querySelectorAll('[data-cbt-signup]').forEach((section) => {
      section.querySelectorAll('[data-cbt-email]').forEach((el) => bindClipbudsEmail(el, cleanups));
    });
  }

  class ClipbudsTemplateSection extends HTMLElement {
    connectedCallback() {
      if (this.dataset.cbtInited === '1') return;
      this.dataset.cbtInited = '1';
      /* 给不支持 :has() 的浏览器补页面标记，避免全站 header 仍吸顶盖住 KV */
      document.documentElement.classList.add('is-cbt-page');

      const cleanups = [];
      this._cbtCleanups = cleanups;
      const reduced = cbtPrefersReducedMotion();
      initClipbudsKvVideo(this, { cleanups });
      initClipbudsKvNav(this, { cleanups, reduced });
      initClipbudsEditionsTabs(this, { cleanups });
      initClipbudsScenes(this, { cleanups });
      initClipbudsCalls(this, { cleanups });
      initClipbudsWorkday(this, { cleanups });
      initClipbudsComfort(this, { cleanups });
      initClipbudsDetail(this, { cleanups });
      initClipbudsGuide(this, { cleanups });
      initClipbudsSpecs(this, { cleanups });
      initClipbudsSignup(this, { cleanups });
      initClipbudsEditionsVariants(this, { cleanups });
      initClipbudsEditionsCodeCopy(this, { cleanups });
      if (window.UgProductCta && typeof window.UgProductCta.init === 'function') {
        window.UgProductCta.init(this, { cleanups });
      }
      const cancelGsapWait = whenGsapReady((ok) => {
        if (!this.isConnected) return;
        initClipbudsScrollReveal(this, {
          cleanups,
          reduced: cbtPrefersReducedMotion(),
          hasGsap: ok
        });
      });
      cleanups.push(cancelGsapWait);
    }

    disconnectedCallback() {
      delete this.dataset.cbtInited;
      (this._cbtCleanups || []).forEach((fn) => {
        try {
          fn();
        } catch (_) {}
      });
      this._cbtCleanups = [];
      window.requestAnimationFrame(() => {
        if (!document.querySelector(TAG_NAME)) {
          document.documentElement.classList.remove('is-cbt-page');
        }
      });
    }
  }

  customElements.define(TAG_NAME, ClipbudsTemplateSection);
})();
